// extracted by mini-css-extract-plugin
export var lineLink = "PreFooter-module--line-link--JiQPM";
export var lineLink_black = "PreFooter-module--line-link_black--DSxHh";
export var lineLink_grey = "PreFooter-module--line-link_grey--mbXEh";
export var lineLink_primary = "PreFooter-module--line-link_primary--isNj3";
export var lineLink_secondary = "PreFooter-module--line-link_secondary--j-Fo+";
export var lineLink_white = "PreFooter-module--line-link_white--kbNl-";
export var section = "PreFooter-module--section--xv942";
export var sectionTitle = "PreFooter-module--sectionTitle--FJn9d";